export const reviews = [
  {
    review:
      "The best butter chicken in Veraval! A must-visit for anyone who loves authentic Indian food.",
    name: "Priya S.",
    rating: 5,
  },
  {
    review:
      "Incredible flavors and great service. The biryani is out of this world. We'll be back soon!",
    name: "Rahul M.",
    rating: 5,
  },
  {
    review:
      "A wonderful place for family dinners. We loved the variety of chaat and kebabs. Highly recommended.",
    name: "The Desai Family",
    rating: 4,
  },
];
